import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconInformation',
  props: {
    className: {},
    classFill: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className),
    width: "20",
    height: _ctx.size || 20,
    viewBox: "0 0 20 20"
  }, [
    _createElementVNode("path", {
      id: "Path_7746",
      class: _normalizeClass([
        _ctx.classFill || 'fill-zbr-primary',
        'svg-fill'
      ]),
      "data-name": "Path 7746",
      d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15H11V11h2Zm0-8H11V7h2Z",
      transform: "translate(-2 -2)"
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})